/* Carrousel vidéos fiche produit (section c2v-video-carousel) */
(function () {
  if (customElements.get('c2v-video-carousel')) return;

  var lang = (location.pathname.match(/^\/(en|de|es|hr|da|el|it|nl|pl|pt|ro|sv|cs)\//) || [])[1] || 'fr';
  var labels = {
    fr: {
      dialog: 'Vidéos', close: 'Fermer', pause: 'Mettre en pause', play: 'Lire',
      mute: 'Couper le son', unmute: 'Activer le son',
      first: 'Première vidéo', prev: 'Vidéo précédente', next: 'Vidéo suivante', last: 'Dernière vidéo',
      scrollPrev: 'Défiler vers la gauche', scrollNext: 'Défiler vers la droite'
    },
    en: {
      dialog: 'Videos', close: 'Close', pause: 'Pause', play: 'Play',
      mute: 'Mute', unmute: 'Unmute',
      first: 'First video', prev: 'Previous video', next: 'Next video', last: 'Last video',
      scrollPrev: 'Scroll left', scrollNext: 'Scroll right'
    }
  };
  var t = labels[lang] || labels.en;

  var svg = function (body, attrs) {
    return '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" ' + (attrs || '') + '>' + body + '</svg>';
  };
  var stroke = 'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"';
  var icons = {
    close: svg('<path d="M6 6l12 12M18 6L6 18"/>', 'fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"'),
    pause: svg('<path fill="currentColor" d="M7 5h3.2v14H7zM13.8 5H17v14h-3.2z"/>'),
    play: '<svg viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path fill="currentColor" d="M4.79062 2.09314C4.63821 1.98427 4.43774 1.96972 4.27121 2.05542C4.10467 2.14112 4 2.31271 4 2.5V12.5C4 12.6873 4.10467 12.8589 4.27121 12.9446C4.43774 13.0303 4.63821 13.0157 4.79062 12.9069L11.7906 7.90687C11.922 7.81301 12 7.66148 12 7.5C12 7.33853 11.922 7.18699 11.7906 7.09314L4.79062 2.09314Z"/></svg>',
    soundOn: svg('<path fill="currentColor" d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 010 7M18.5 5.5a9 9 0 010 13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>'),
    soundOff: svg('<path fill="currentColor" d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M16 9l6 6M22 9l-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>'),
    first: svg('<path d="M17 18l-6-6 6-6M11 18l-6-6 6-6"/>', stroke),
    prev: svg('<path d="M15 18l-6-6 6-6"/>', stroke),
    next: svg('<path d="M9 18l6-6-6-6"/>', stroke),
    last: svg('<path d="M7 18l6-6-6-6M13 18l6-6-6-6"/>', stroke)
  };

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  class C2VVideoCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('.c2v-vc__track');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.c2v-vc__card'));
      this.navPrev = this.querySelector('.c2v-vc__nav--prev');
      this.navNext = this.querySelector('.c2v-vc__nav--next');
      if (!this.track || !this.cards.length) return;

      if (this.navPrev) this.navPrev.setAttribute('aria-label', t.scrollPrev);
      if (this.navNext) this.navNext.setAttribute('aria-label', t.scrollNext);

      this.onKey = this.onKey.bind(this);
      this.updateNav = this.updateNav.bind(this);

      this.cards.forEach(function (card, i) {
        card.addEventListener('click', this.open.bind(this, i));
        card.addEventListener('mouseenter', this.preview.bind(this, card, true));
        card.addEventListener('mouseleave', this.preview.bind(this, card, false));
      }, this);

      [this.navPrev, this.navNext].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener('click', function () {
          var dir = Number(btn.getAttribute('data-dir')) || 1;
          this.track.scrollBy({ left: dir * this.track.clientWidth * 0.8, behavior: 'smooth' });
        }.bind(this));
      }, this);

      this.track.addEventListener('scroll', this.updateNav, { passive: true });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateNav);
        this.resizeObserver.observe(this.track);
      }
      this.updateNav();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      this.close();
    }

    updateNav() {
      var max = this.track.scrollWidth - this.track.clientWidth;
      var overflowing = max > 2;
      if (this.navPrev) this.navPrev.hidden = !overflowing || this.track.scrollLeft <= 2;
      if (this.navNext) this.navNext.hidden = !overflowing || this.track.scrollLeft >= max - 2;
    }

    preview(card, active) {
      if (!canHover.matches) return;
      var video = card.querySelector('.c2v-vc__preview');
      if (active) {
        if (!video) {
          video = document.createElement('video');
          video.className = 'c2v-vc__preview';
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.setAttribute('aria-hidden', 'true');
          video.preload = 'auto';
          video.src = card.getAttribute('data-preview') || card.getAttribute('data-src');
          video.addEventListener('playing', function () {
            if (card.matches(':hover')) card.classList.add('is-previewing');
          });
          card.insertBefore(video, card.querySelector('.c2v-vc__play'));
        }
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      } else if (video) {
        video.pause();
        card.classList.remove('is-previewing');
      }
    }

    /* Lecteur plein écran */

    open(index) {
      if (this.modal) return;
      this.cards.forEach(function (card) { this.preview(card, false); }, this);
      this.lastFocus = document.activeElement;
      this.muted = false;

      var bars = this.cards.map(function () {
        return '<span class="c2v-vc-modal__bar"><span class="c2v-vc-modal__fill"></span></span>';
      }).join('');
      var cta = this.getAttribute('data-cta');

      var modal = document.createElement('div');
      modal.className = 'c2v-vc-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', t.dialog);
      modal.innerHTML =
        '<div class="c2v-vc-modal__nav">' +
          '<button type="button" class="c2v-vc-modal__arrow" data-action="first" aria-label="' + t.first + '">' + icons.first + '</button>' +
          '<button type="button" class="c2v-vc-modal__arrow" data-action="prev" aria-label="' + t.prev + '">' + icons.prev + '</button>' +
        '</div>' +
        '<div class="c2v-vc-modal__stage">' +
          '<div class="c2v-vc-modal__progress">' + bars + '</div>' +
          '<video class="c2v-vc-modal__video" playsinline preload="auto"></video>' +
          '<button type="button" class="c2v-vc-modal__tap c2v-vc-modal__tap--prev" data-action="prev" tabindex="-1" aria-hidden="true"></button>' +
          '<button type="button" class="c2v-vc-modal__tap c2v-vc-modal__tap--next" data-action="next" tabindex="-1" aria-hidden="true"></button>' +
          '<div class="c2v-vc-modal__controls">' +
            '<button type="button" class="c2v-vc-modal__ctrl" data-action="close" aria-label="' + t.close + '">' + icons.close + '</button>' +
            '<button type="button" class="c2v-vc-modal__ctrl" data-action="toggle"></button>' +
            '<button type="button" class="c2v-vc-modal__ctrl" data-action="mute"></button>' +
          '</div>' +
          (cta ? '<button type="button" class="c2v-vc-modal__cta" data-action="cta"></button>' : '') +
        '</div>' +
        '<div class="c2v-vc-modal__nav">' +
          '<button type="button" class="c2v-vc-modal__arrow" data-action="next" aria-label="' + t.next + '">' + icons.next + '</button>' +
          '<button type="button" class="c2v-vc-modal__arrow" data-action="last" aria-label="' + t.last + '">' + icons.last + '</button>' +
        '</div>';

      if (cta) modal.querySelector('.c2v-vc-modal__cta').textContent = cta;

      this.modal = modal;
      this.video = modal.querySelector('.c2v-vc-modal__video');
      this.fills = Array.prototype.slice.call(modal.querySelectorAll('.c2v-vc-modal__fill'));
      this.toggleBtn = modal.querySelector('[data-action="toggle"]');
      this.muteBtn = modal.querySelector('[data-action="mute"]');

      modal.addEventListener('click', function (event) {
        var target = event.target.closest('[data-action]');
        if (!target) {
          if (event.target === modal) this.close();
          return;
        }
        if (target.getAttribute('aria-disabled') === 'true') return;
        switch (target.getAttribute('data-action')) {
          case 'close': this.close(); break;
          case 'toggle': this.togglePlay(); break;
          case 'mute': this.toggleMute(); break;
          case 'first': this.go(0); break;
          case 'prev': this.go(this.index - 1); break;
          case 'next': this.go(this.index + 1); break;
          case 'last': this.go(this.cards.length - 1); break;
          case 'cta': this.goToOffer(); break;
        }
      }.bind(this));

      this.video.addEventListener('timeupdate', this.updateProgress.bind(this));
      this.video.addEventListener('play', this.updateToggle.bind(this));
      this.video.addEventListener('pause', this.updateToggle.bind(this));
      this.video.addEventListener('ended', function () {
        if (this.index < this.cards.length - 1) this.go(this.index + 1);
      }.bind(this));

      document.body.appendChild(modal);
      document.documentElement.classList.add('c2v-vc-lock');
      document.addEventListener('keydown', this.onKey);

      this.updateMute();
      this.go(index);
      modal.querySelector('[data-action="close"]').focus({ preventScroll: true });
    }

    go(index) {
      if (!this.modal) return;
      var last = this.cards.length - 1;
      if (index < 0 || index > last) return;
      this.index = index;

      var card = this.cards[index];
      this.video.pause();
      this.video.poster = card.getAttribute('data-poster') || '';
      this.video.src = card.getAttribute('data-src');
      this.video.muted = this.muted;

      this.fills.forEach(function (fill, i) {
        fill.style.width = i < index ? '100%' : '0%';
      });

      var atStart = index === 0;
      var atEnd = index === last;
      this.modal.querySelectorAll('.c2v-vc-modal__arrow').forEach(function (btn) {
        var action = btn.getAttribute('data-action');
        var disabled = (action === 'first' || action === 'prev') ? atStart : atEnd;
        btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      });

      this.play();
    }

    play() {
      var video = this.video;
      var attempt = video.play();
      if (attempt && attempt.catch) {
        attempt.catch(function () {
          // Lecture avec son refusée par le navigateur : on relance en muet.
          this.muted = true;
          video.muted = true;
          this.updateMute();
          var retry = video.play();
          if (retry && retry.catch) retry.catch(function () {});
        }.bind(this));
      }
    }

    togglePlay() {
      if (this.video.paused) this.play();
      else this.video.pause();
    }

    toggleMute() {
      this.muted = !this.muted;
      this.video.muted = this.muted;
      this.updateMute();
    }

    updateToggle() {
      var paused = this.video.paused;
      this.toggleBtn.innerHTML = paused ? icons.play : icons.pause;
      this.toggleBtn.setAttribute('aria-label', paused ? t.play : t.pause);
    }

    updateMute() {
      this.muteBtn.innerHTML = this.muted ? icons.soundOff : icons.soundOn;
      this.muteBtn.setAttribute('aria-label', this.muted ? t.unmute : t.mute);
    }

    updateProgress() {
      var fill = this.fills[this.index];
      if (!fill || !this.video.duration) return;
      fill.style.width = Math.min(100, (this.video.currentTime / this.video.duration) * 100) + '%';
    }

    goToOffer() {
      this.close();
      var target =
        document.querySelector('.product__block--buy_buttons') ||
        document.querySelector('form[action*="/cart/add"]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    onKey(event) {
      if (event.key === 'Escape') this.close();
      else if (event.key === 'ArrowLeft') this.go(this.index - 1);
      else if (event.key === 'ArrowRight') this.go(this.index + 1);
    }

    close() {
      if (!this.modal) return;
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
      this.modal.remove();
      this.modal = null;
      document.documentElement.classList.remove('c2v-vc-lock');
      document.removeEventListener('keydown', this.onKey);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }
  }

  customElements.define('c2v-video-carousel', C2VVideoCarousel);
})();
